import { STATUS_LABELS } from '../utils';

export function StatusDot({ status = 'current', label = true }) {
  return (
    <span className={`status status--${status}`}>
      <span className="status__dot" aria-hidden="true" />
      {label ? <span>{STATUS_LABELS[status] ?? status}</span> : null}
    </span>
  );
}

export function LiveState({ connected, compact = false, readOnly = false }) {
  return (
    <div className={`live-state ${connected ? 'is-connected' : ''}`} title={readOnly ? 'Live local dashboard with a read-only memory source' : 'Live local dashboard'}>
      <span className="live-state__dot" />
      <span>{connected ? 'Live' : 'Reconnecting'}</span>
      {!compact ? <><span>·</span><span>Local</span>{readOnly ? <><span>·</span><span>Source read only</span></> : null}</> : readOnly ? <><span>·</span><span>Snapshot</span></> : null}
    </div>
  );
}
